module.exports = __webpack_public_path__ + "static/img/gongzhonghao.5fa4cb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contactus/gongzhonghao.png
// module id = x6mk
// module chunks = 51